import styles from './HomePage.module.css';

function HomePage() {
    return (
        <div className={styles['welcome-container']}>
            <h1>Great Telepresence welcome page</h1>
        </div>
    );
}

export default HomePage;
